import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const prod: IPartnerAppSettings = {
  cdnBaseUrl: 'https://esxp-prod-cvfnbvbahdefhucx.b02.azurefd.net/weekly-digest',
  serviceEndPoints: [
    {
      clientId: 'api://2a5ea82d-af4c-494d-9d60-79db20d2ebd1',
      serviceEndPoint: 'https://professionalservices.microsoft.com/csp-api',
    },
    {
      clientId: 'api://2a5ea82d-af4c-494d-9d60-79db20d2ebd1',
      serviceEndPoint: 'https://fd-csp-prod-gdf7b6ambzheftcy.z01.azurefd.net/csp-api',
    },
    {
      clientId: 'e42b0f1c-114a-42a1-853a-089f1ab22b22',
      serviceEndPoint: 'https://professionalservices.microsoft.com/rmsvc',
    },
    {
      clientId: 'e42b0f1c-114a-42a1-853a-089f1ab22b22',
      serviceEndPoint: 'https://professionalservices.microsoft.com/rm-customers-api',
    },
    {
      clientId: 'cc1b9d80-0cfd-42dc-aea1-c610b6393ab9',
      serviceEndPoint: 'https://flighting-api-prod.azurefd.net/'
    },
    {
      clientId: 'api://2a5ea82d-af4c-494d-9d60-79db20d2ebd1',
      serviceEndPoint: 'https://fd-csp-powerpoint-export-prod-hzdxcxg3drc9a6ed.z01.azurefd.net/api',
    },
    {
      clientId: '42b54676-98ae-4f65-98a9-b881a7645526',
      serviceEndPoint: 'https://esxp.microsoft.com/mdm'
    },
    {
      clientId: '6db56845-5ebb-4b74-88d0-28cc0e41e163',
      serviceEndPoint: 'https://professionalservices.microsoft.com/dm/'
    },
    {
      clientId: 'api://b7d6d56f-a99c-40c5-8099-e47c6530908a',
      serviceEndPoint: 'https://hygieneprod.trafficmanager.net/'
    },
    {
      clientId: 'api://fc8c87b7-2b16-4641-b29d-f8e668c9838e',
      serviceEndPoint: 'https://nebulaapi.azurefd.net/'
    }
  ],
  HygieneAppConfiguration: {
    'HygieneBaseUri': 'https://hygieneprod.trafficmanager.net',
    'GetHierarchy': '/api/GetHierarchy?identifier=%s',
    'GetFactoryWorkloadMilestones': '/api/Milestone/GetEngagementMilestonesByOwner?ownerId=%s',
    'FactoryEligibleMilestonesUrl': 'https://microsoft.seismic.com/Link/Content/DCQC3mp4RQCgbGfRVF74997bVBmB#/?anchorId=9dbb39ba-cc9b-4f68-9a5a-6a5cfcd1de57'
  },
  NebulaAppConfiguration: {
    'NebulaApiBaseUrl': 'https://nebulaapi.azurefd.net',
    'NebulaSubscriptionKey': '8B16D17C-6C3E-4079-8D4D-2FADFD9E62F0',
    'NebulaAuthScope': 'api://fc8c87b7-2b16-4641-b29d-f8e668c9838e/.default',
    'NebulaCmpSubscriptionKey': '02642B6E-676C-48D0-B377-4C16985A0993',
  },
  MSXAppConfiguration: {
    'MSXBaseUrl': 'https://microsoftsales.crm.dynamics.com/main.aspx?appid=33241e95-ccc7-ee11-907b-6045bdef6f72&',
    'ESXPCustomersBaseUrl': 'https://esxp.microsoft.com/#/customers'
  }
};
